// src/utils/prioritaOperative.js
// ═══════════════════════════════════════════════════════════════════════════
// PRIORITÀ OPERATIVE — definizioni uniche (ottobre 2026), usate da Nexiora Insight per i
// conteggi e dal Centro Operativo per l'elenco che si apre al clic: così il numero visto in
// Insight è lo stesso che si ritrova nell'elenco.
// Contano attività E sottoattività delle sole commesse aperte (utils/economiaCommessa.js →
// commessaAperta). Il ritardo è quello di isTaskOverdue (esclude completate, annullate,
// sospese; rispetta l'orario di scadenza).
// ═══════════════════════════════════════════════════════════════════════════
import { isTaskOverdue } from "./taskHelpers";
import { toLocalDateStr } from "./dateUtils";
import { commessaAperta } from "./economiaCommessa";

const CHIUSI = ["completata", "annullata", "sospesa"];
export const attivitaAperta = (t) => !!t && !CHIUSI.includes(t.status) && !t.archived;

/** Attività e sottoattività delle commesse aperte (la sottoattività prende la commessa dall'attività madre). */
export function vociCommesseAperte({ tasks = [], subtasks = [], projects = [] }) {
  const aperte = new Set(projects.filter(commessaAperta).map(p => p.id));
  const madri = new Map(tasks.map(t => [t.id, t]));
  const t1 = tasks.filter(t => aperte.has(t.projectId));
  const t2 = subtasks.filter(s => { const m = madri.get(s.parentTaskId); return m && aperte.has(m.projectId); })
    .map(s => ({ ...s, projectId: s.projectId || madri.get(s.parentTaskId)?.projectId, sottoattivita: true }));
  return [...t1, ...t2];
}

const giorni = (n, da = new Date()) => { const d = new Date(da); d.setDate(d.getDate() + n); return toLocalDateStr(d); };
const ms = (ts) => (ts?.toDate ? ts.toDate().getTime() : (ts ? new Date(ts).getTime() : 0));

/** Gli elenchi delle priorità operative. */
export function elenchiPriorita(voci = [], adesso = new Date()) {
  const oggi = toLocalDateStr(adesso), tra7 = giorni(7, adesso);
  const limiteFerme = adesso.getTime() - 14 * 86400000;
  return {
    inRitardo: voci.filter(t => isTaskOverdue(t)),
    scadonoOggi: voci.filter(t => t.dueDate === oggi && attivitaAperta(t) && !isTaskOverdue(t)),
    nonAssegnate: voci.filter(t => attivitaAperta(t) && !t.assignedTo && t.dueDate && t.dueDate <= tra7),
    // «In corso» ma senza aggiornamenti da oltre 14 giorni; le scadute stanno già in «In ritardo»
    ferme: voci.filter(t => !t.sottoattivita && t.status === "in_corso" && !t.archived && !isTaskOverdue(t) &&
      (ms(t.updatedAt) || ms(t.createdAt)) > 0 && (ms(t.updatedAt) || ms(t.createdAt)) < limiteFerme),
  };
}

export const TITOLI_ELENCHI = {
  inRitardo: "Attività in ritardo (commesse aperte)",
  scadonoOggi: "Attività che scadono oggi",
  nonAssegnate: "Attività senza responsabile in scadenza entro 7 giorni",
  ferme: "Attività in corso senza aggiornamenti da oltre 14 giorni",
};
